import React from "react"
import { makeStyles } from "makeStyles"
import { connectHits } from "react-instantsearch-dom"
import { HitsProvided } from "react-instantsearch-core"

import GridView from "components/Algolia/Results/GridView"
import ListView from "components/Algolia/Results/ListView"
import MobileView from "components/Algolia/Results/MobileView"

import { AlgoliaUIPageType } from "../AlgoliaSearchUI"
import { AlgoliaProductHit } from "@secureo/common/typings/Algolia"

const useStyles = makeStyles()({
	desktop: {
		display: "block",
	},
	mobile: {
		display: "none",
	},
	"@media only screen and (max-width: 600px)": {
		desktop: {
			display: "none",
		},
		mobile: {
			display: "block",
		},
	},
})

const Results = ({
	isListView,
	hits,
	locale,
	categoryName,
	pageType,
}: Props & HitsProvided<AlgoliaProductHit>) => {
	const { classes } = useStyles()

	return (
		<div>
			<div className={classes.desktop}>
				{isListView ? (
					<ListView
						hits={hits}
						locale={locale}
						categoryName={categoryName}
						pageType={pageType}
					/>
				) : (
					<GridView
						hits={hits}
						locale={locale}
						categoryName={categoryName}
						pageType={pageType}
					/>
				)}
			</div>
			<div className={classes.mobile}>
				<MobileView
					hits={hits}
					locale={locale}
					categoryName={categoryName}
					pageType={pageType}
				/>
			</div>
		</div>
	)
}

interface Props {
	isListView: boolean
	locale: string
	categoryName: string
	pageType: AlgoliaUIPageType
}

const ExposedResults: React.ComponentClass<Props> = connectHits(Results)

export default ExposedResults
